import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from "@angular/core";

require('./bringoz-checkbox.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-checkbox',
  templateUrl: './bringoz-checkbox.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCheckboxComponent implements OnChanges, AfterViewInit {

  @Input() isDisabled: boolean = false;
  @Input() isChecked: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() isIndeterminate: boolean = false;
  @Input() supportNullState?: boolean = false;
  @Input() stopClickPropagation: boolean = true;
  @Output() clickEvent = new EventEmitter<any>();

  @ViewChild('checkbox') checkbox: any;

  constructor(@Inject('$timeout') private $timeout) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isIndeterminate || changes.isChecked) {
      this.setIndeterminateState();
    }
  }

  ngAfterViewInit() {
    this.setIndeterminateState();
  }

  onClick(event) {
    if (this.stopClickPropagation) {
      event.stopPropagation();
    }
    this.clickEvent.emit(event);

    this.$timeout(0).then(() => {
    });
  }

  private setIndeterminateState() {
    if (this.checkbox) {
      this.checkbox.nativeElement.checked = this.isChecked;
      this.checkbox.nativeElement.indeterminate = this.isIndeterminate;
    }
  }

}
